import { downloadBlobFile } from '@/utils/index'
import { Message } from 'element-ui'

export default {
  fetchWrapper(fetch, { type, success, fail }) {
    fetch
      .then(res => {
        console.log('fetchWrapper success')
        switch (type) {
            case 'list':
              if (
                res.data.result === 0 ||
              res.data.result === -13 ||
              res.data.result === 13
              ) {
                success && success(res)
              } else {
                Message.error(res.data.message)
                fail && fail()
              }
              break
            case 'info':
              if (res.data.result === 0) {
                success && success(res)
              } else {
                Message.error(res.data.message)
                fail && fail()
              }
              break
            case 'action':
              if (res.data.result === 0) {
                Message.success(res.data.message)
                success && success(res)
              } else {
                Message.error(res.data.message)
                fail && fail()
              }
              break
            case 'file':
              downloadBlobFile(res)
              success && success()
              break
        }
      })
      .catch(err => {
        console.log(err, 'fetchWrapper fail')
        Message.error(err.message)
        fail && fail(err)
      })
  },
  storeActionsMapper(Service, fetch) {
    return Object.keys(Service).reduce((pre, cur) => {
      pre[cur] = (context, { payload, type, success, fail }) => {
        fetch(Service[cur](payload), {
          type,
          success,
          fail
        })
      }
      console.log(pre)
      return pre
    }, {})
  }
}
